import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/medrt': {
    width: 544,
    height: 512,
    paths: [
      {
        d: 'M113.7 256C113.7 377.8 197.6 478.8 307.2 497.1 288.5 501.6 269 504 249 504 111.4 504 0 393 0 256S111.4 8 248.9 8C269 8 288.5 10.4 307.1 14.9 197.5 33.2 113.7 134.2 113.7 256M411.1 356.3C333.4 411.7 231.5 403.8 170.7 341.7 176.2 355.8 183.4 369.4 192.4 382.2 254 470.4 374.8 491.5 462.1 429.2 549.4 366.9 570.2 244.9 508.6 156.6 499.6 143.7 489.3 132.3 478.1 122.4 515.5 201.2 488.8 300.9 411.1 356.3M192.3 112.3C190.9 113.3 189.6 114.4 188.3 115.4 252.6 97.6 324.2 119.4 367.2 175.9 402.9 222.9 410.1 282.5 391.6 333.9 448.3 277.7 459.2 191.8 413.9 132.1 363.9 66.6 264.8 57.7 192.3 112.3M296 224C291.6 224 288 220.4 288 216V176C288 171.6 284.4 168 280 168H232C227.6 168 224 171.6 224 176V216C224 220.4 220.4 224 216 224H176C171.6 224 168 227.6 168 232V280C168 284.4 171.6 288 176 288H216C220.4 288 224 291.6 224 296V336C224 340.4 227.6 344 232 344H280C284.4 344 288 340.4 288 336V296C288 291.6 291.6 288 296 288H336C340.4 288 344 284.4 344 280V232C344 227.6 340.4 224 336 224H296z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/medrt.js
// module id = LPTI
// module chunks = 144